import {
  createAsyncThunk,
  createSlice,
} from '@reduxjs/toolkit';

import axios from 'axios';


/* global process */

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL;

const OPPORTUNITIES_URL =
  `${API_BASE_URL}/api/v1/opportunities`;


const initialState = {
  items: [],
  status: 'idle',
  error: null,
};


export const fetchOpportunities =
  createAsyncThunk(
    'opportunities/fetchOpportunities',
    async (_, { rejectWithValue }) => {
      try {
        const response = await axios.get(
          OPPORTUNITIES_URL
        );

        return response.data;
      } catch (error) {
        return rejectWithValue(
          error.response?.data?.error ||
          error.message ||
          'Unable to load opportunities.'
        );
      }
    }
  );


const opportunitiesSlice = createSlice({
  name: 'opportunities',

  initialState,

  reducers: {},

  extraReducers: (builder) => {
    builder

      .addCase(
        fetchOpportunities.pending,
        (state) => {
          state.status = 'loading';
          state.error = null;
        }
      )

      .addCase(
        fetchOpportunities.fulfilled,
        (state, action) => {
          state.status = 'succeeded';
          state.items = action.payload;
          state.error = null;
        }
      )

      .addCase(
        fetchOpportunities.rejected,
        (state, action) => {
          state.status = 'failed';

          state.error =
            action.payload ||
            action.error.message;
        }
      );
  },
});


export const selectAllOpportunities =
  (state) => state.opportunities.items;

export const getOpportunitiesStatus =
  (state) => state.opportunities.status;

export const getOpportunitiesError =
  (state) => state.opportunities.error;


export default opportunitiesSlice.reducer;
